import { AIService } from './AIService';
import { 
  PlaylistData, 
  AnalysisType, 
  ChatResponse 
} from './types';
import { log } from './utils';

export class PlaylistAnalysisService {
  constructor(private aiService: AIService) {}
  
  // Analyze a playlist and provide insights
  public async analyzePlaylist(
    playlist: PlaylistData,
    analysisType: AnalysisType = 'all'
  ): Promise<ChatResponse> {
    let prompt = `Please analyze this playlist:`;
    prompt += `\nName: ${playlist.playlist_name}`;
    prompt += `\nDescription: ${playlist.description}`;
    prompt += `\nTracks:`;
    
    playlist.tracks.forEach((track, index) => {
      prompt += `\n${index + 1}. "${track.track}" by ${track.artist}`;
    });
    
    prompt += `\n\nAnalysis type: ${analysisType}`;
    
    prompt += `\n\nPlease provide insights about this playlist including:`;
    
    if (analysisType === 'all' || analysisType === 'general') {
      prompt += `\n- Overall theme and coherence`;
      prompt += `\n- Standout tracks`;
      prompt += `\n- Musical journey`;
    }
    
    if (analysisType === 'all' || analysisType === 'genre') {
      prompt += `\n- Genre distribution and primary genres`;
      prompt += `\n- Genre coherence or diversity`;
    }
    
    if (analysisType === 'all' || analysisType === 'mood') {
      prompt += `\n- Mood assessment`;
      prompt += `\n- Emotional journey`;
    }
    
    if (analysisType === 'all' || analysisType === 'era') {
      prompt += `\n- Era distribution`;
      prompt += `\n- Historical context`;
    }
    
    prompt += `\n\nPlease format your analysis as a JSON object with the following structure:
    {
      "analysis": {
        "summary": "Overall description of the playlist",
        "genres": ["Primary genre", "Secondary genre", "Other genres"],
        "mood": "Overall mood assessment",
        "era_distribution": {"1960s": 10, "1970s": 30, "1980s": 40, "1990s": 20},
        "highlights": ["Notable aspect 1", "Notable aspect 2"],
        "recommendations": ["Suggestion 1", "Suggestion 2"]
      }
    }`;
    
    log('Analyzing playlist with prompt:', prompt);
    const response = await this.aiService.sendMessage(prompt);
    return response;
  }
}
